import SMFormFieldText from './SMFormFieldText';

export default SMFormFieldText;
